import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { AchEnrollmentService } from '@src/app/features/ach-enrollment/services/ach-enrollment.service';
import { of } from 'rxjs';
import { catchError, concatMap, map, tap } from 'rxjs/operators';
import * as achEnrollmentActions from '../actions/ach-enrollment.actions';

@Injectable({
    providedIn: 'root',
})
export class AchEnrollmentEffects {
    createAchEnrollment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(achEnrollmentActions.createAchEnrollment),
            concatMap((action) =>
                this.achEnrollmentService.createAchEnrollment(action.achEnrollment).pipe(
                    map(() => achEnrollmentActions.createAchEnrollmentSuccess()),
                    catchError(() => {
                        return of(achEnrollmentActions.createAchEnrollmentFailure());
                    })
                )
            )
        )
    );

    createAchEnrollmentSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(achEnrollmentActions.createAchEnrollmentSuccess),
                tap(() => {
                    this.router.navigate(['/ach/enrollment-success']);
                })
            ),
        { dispatch: false }
    );

    createAchEnrollmentFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(achEnrollmentActions.createAchEnrollmentFailure),
                tap(() => {
                    this.router.navigate(['/ach/error']);
                })
            ),
        { dispatch: false }
    );

    constructor(
        private readonly actions$: Actions,
        private achEnrollmentService: AchEnrollmentService,
        private router: Router
    ) {}
}
